import React, { useContext } from 'react';
import { AppContext } from 'App.context';
import { ReactComponent as RoomSingleIcon } from 'assets/images/room-single.svg';
import { ReactComponent as RoomStandardDoubleIcon } from 'assets/images/room-standard-double.svg';
import { ReactComponent as RoomDoubleDeluxIcon } from 'assets/images/room-double-delux.svg';
import { ReactComponent as RoomSuiteIcon } from 'assets/images/room-suite.svg';

import './RoomDetail.css';

export default function RoomDetail({ number, type }) {
  const {
    appActions: { translate },
  } = useContext(AppContext);
  const typeOptions = {
    single: {
      icon: <RoomSingleIcon />,
      name: translate('createBooking.steps.selectRooms.roomTypes.single'),
      className: 'room-single',
    },
    standardDouble: {
      icon: <RoomStandardDoubleIcon />,
      name: translate('createBooking.steps.selectRooms.roomTypes.standardDouble'),
      className: 'room-standard-double',
    },
    doubleDelux: {
      icon: <RoomDoubleDeluxIcon />,
      name: translate('createBooking.steps.selectRooms.roomTypes.doubleDelux'),
      className: 'room-double-delux',
    },
    suite: {
      icon: <RoomSuiteIcon />,
      name: translate('createBooking.steps.selectRooms.roomTypes.suite'),
      className: 'room-suite',
    },
  };

  const currentType = typeOptions[type];
  return number ? (
    <div className={`room-detail ${currentType.className}`}>
      {currentType.icon} {currentType.name}
      {number ? <span className="room-detail-number">{number}</span> : null}
    </div>
  ) : null;
}
